export default __webpack_public_path__ + "static/media/brandsImage-1.5a255980.jpg";